// extracted by mini-css-extract-plugin
module.exports = {"mony":"mony_mony_wfe4f","title":"mony_title_3dl0m"};